module.exports = __webpack_public_path__ + "images/empty-icon-83a348.svg";